import React from 'react';

const Services: React.FC = () => {
  const services = [
    {
      id: 1,
      title: '企画',
      description: 'お客様のビジネス目標を深く理解し、ターゲット層に響く戦略を立案。市場調査からコンセプト設計まで、成功への道筋を描きます。',
      icon: 'ri-lightbulb-line',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20purple%20violet%20strategic%20planning%20concept%20geometric%20shapes%20mind%20map%20visualization%20modern%20elegant%20design%20sophisticated%20atmosphere%20professional%20no%20people&width=800&height=600&seq=service-planning-3301&orientation=landscape'
    },
    {
      id: 2,
      title: '制作',
      description: 'Webサイト、動画、グラフィックなど、あらゆるデジタルコンテンツを制作。最新のデザイントレンドと技術で、魅力的な作品を生み出します。',
      icon: 'ri-palette-line',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20purple%20violet%20creative%20design%20tools%20digital%20canvas%20layers%20modern%20elegant%20composition%20sophisticated%20atmosphere%20professional%20concept%20no%20people&width=800&height=600&seq=service-production-3302&orientation=landscape'
    },
    {
      id: 3,
      title: '管理・運営',
      description: 'コンテンツの公開後も、継続的な改善とメンテナンスでサポート。アクセス解析やSEO対策で、効果を最大化します。',
      icon: 'ri-settings-3-line',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20purple%20violet%20data%20analytics%20dashboard%20graphs%20charts%20modern%20elegant%20visualization%20sophisticated%20atmosphere%20professional%20concept%20no%20people&width=800&height=600&seq=service-management-3303&orientation=landscape'
    },
    {
      id: 4,
      title: '販売',
      description: 'ECサイト構築からマーケティング戦略まで、オンライン販売を総合的にサポート。売上向上を実現します。',
      icon: 'ri-shopping-cart-line',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20purple%20violet%20e-commerce%20concept%20shopping%20icons%20digital%20payment%20symbols%20modern%20elegant%20design%20sophisticated%20atmosphere%20professional%20no%20people&width=800&height=600&seq=service-sales-3304&orientation=landscape'
    },
    {
      id: 5,
      title: 'プロデュース',
      description: 'ブランディングからプロモーションまで、トータルでプロデュース。お客様のビジネスを次のステージへと導きます。',
      icon: 'ri-star-line',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20purple%20violet%20brand%20identity%20concept%20elegant%20geometric%20patterns%20modern%20sophisticated%20design%20professional%20atmosphere%20no%20people&width=800&height=600&seq=service-produce-3305&orientation=landscape'
    }
  ];

  return (
    <section className="py-32 bg-gradient-to-b from-purple-50 to-fuchsia-50 relative overflow-hidden" id="services">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 right-0 w-96 h-96 bg-fuchsia-600 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-purple-900 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-block mb-6 px-8 py-3 bg-gradient-to-r from-purple-900 to-violet-900 rounded-full border-2 border-fuchsia-400">
            <span className="text-purple-100 text-sm font-black tracking-widest" style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}>
              OUR SERVICES
            </span>
          </div>
          <h2 className="text-5xl md:text-6xl font-black text-purple-900 mb-6" style={{ fontFamily: '"Shippori Mincho", serif' }}>
            サービス内容
          </h2>
          <p className="text-xl text-stone-700 max-w-3xl mx-auto leading-relaxed font-bold" style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}>
            企画から制作、運営、販売、プロデュースまで、<br />
            ウェブコンテンツ事業の全てをワンストップでサポートします
          </p>
        </div>

        {/* 独創的なジグザグレイアウト */}
        <div className="space-y-24">
          {services.map((service, index) => (
            <div 
              key={service.id} 
              className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-12 items-center`}
            >
              {/* 画像部分 */}
              <div className="w-full lg:w-1/2 group">
                <div className="relative overflow-hidden rounded-3xl shadow-2xl border-4 border-purple-900/20 hover:border-fuchsia-400 transition-all duration-500 hover:scale-105">
                  <img 
                    src={service.image} 
                    alt={service.title}
                    className="w-full h-80 object-cover object-top transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-purple-900 via-purple-900/50 to-transparent opacity-70 group-hover:opacity-50 transition-opacity duration-500"></div>
                  <div className={`absolute ${index % 2 === 0 ? 'bottom-8 left-8' : 'bottom-8 right-8'}`}>
                    <div className="w-20 h-20 bg-gradient-to-br from-fuchsia-400 to-violet-500 rounded-2xl flex items-center justify-center border-4 border-white/30 shadow-2xl">
                      <i className={`${service.icon} text-4xl text-white w-10 h-10 flex items-center justify-center`}></i>
                    </div>
                  </div>
                </div>
              </div>

              {/* テキスト部分 */}
              <div className="w-full lg:w-1/2">
                <div className="bg-white rounded-3xl p-10 shadow-xl border-2 border-purple-100 hover:shadow-2xl transition-all duration-300">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-12 h-12 bg-gradient-to-br from-fuchsia-400 to-violet-500 rounded-xl flex items-center justify-center">
                      <span className="text-white font-black text-xl" style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}>
                        {String(service.id).padStart(2, '0')}
                      </span>
                    </div>
                    <h3 className="text-4xl font-black text-purple-900" style={{ fontFamily: '"Shippori Mincho", serif' }}>
                      {service.title}
                    </h3>
                  </div>
                  <p className="text-stone-700 leading-relaxed text-lg font-bold" style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}>
                    {service.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
